import * as TipoFuente from "../constantes/TipoFuente.js";

export const DescripcionFuente = (fuenteInformacion) => {
  let descripcion = "";
  if (fuenteInformacion) {
    if (fuenteInformacion.tipoFuente && Number(fuenteInformacion.tipoFuente.codigo) !== Number(TipoFuente.SITIO_WEB)) {
      descripcion = fuenteInformacion.tipoFuente.descripcion + " ";
    }
    descripcion += fuenteInformacion.nombre;
    if (fuenteInformacion.pais) {
      let textoGeo = fuenteInformacion.pais.nombre;
      if (fuenteInformacion.provincia) {
        if (fuenteInformacion.localidad) {
          if (fuenteInformacion.nombre.toLowerCase().includes(fuenteInformacion.localidad.nombre.toLowerCase())) {
            textoGeo = fuenteInformacion.provincia.nombre;
          } else {
            textoGeo = fuenteInformacion.localidad.nombre;
          }
        } else if (!fuenteInformacion.nombre.toLowerCase().includes(fuenteInformacion.provincia.nombre.toLowerCase())) {
          textoGeo = fuenteInformacion.provincia.nombre;
        }
      }
      descripcion += " (" + textoGeo + ")";
    }
  }
  return descripcion;
};
